import { FunctionComponent } from "react";

import { FontSizes, FontWeights, Stack, Text, useTheme } from "@bps/fluent-ui";

import { ErrorResult } from "../../api/base";
import { FormStatusEnum } from "../../hooks/useFormApi.types";

interface VerifyPinFormErrorProps {
  attempts: number;
  error: ErrorResult | undefined;
}

const MAX_ATTEMPTS = 10;
const numbersAsStrings = [
  "One",
  "Two",
  "Three",
  "Four",
  "Five",
  "Six",
  "Seven",
  "Eight",
  "Nine"
];

export const VerifyPinFormError: FunctionComponent<VerifyPinFormErrorProps> = ({
  attempts,
  error
}) => {
  const theme = useTheme();

  let errorMessageContent: string[] = [];

  if (error?.status === FormStatusEnum.PinRequired) {
    errorMessageContent = ["The date of birth is incorrect"];

    const attemptNum = numbersAsStrings[MAX_ATTEMPTS - attempts - 1];
    if (attemptNum) {
      errorMessageContent.push(
        `${numbersAsStrings[MAX_ATTEMPTS - attempts - 1]} attempt(s) remaining`
      );
    }
  } else if (error?.status === FormStatusEnum.TooManyAttempts) {
    errorMessageContent = ["Access attempt limit reached"];
  }

  if (errorMessageContent.length) {
    return (
      <Stack
        tokens={{ childrenGap: 8 }}
        styles={{
          root: {
            background: theme.semanticColors.errorBackground,
            border: `2px solid ${theme.semanticColors.errorText}`,
            padding: 12,
            textAlign: "center",
            borderRadius: 6
          }
        }}
      >
        {errorMessageContent.map(str => (
          <Text
            key={str}
            styles={{
              root: {
                color: theme.semanticColors.errorText,
                fontWeight: FontWeights.semibold,
                fontSize: FontSizes.size12
              }
            }}
          >
            {str}
          </Text>
        ))}
      </Stack>
    );
  }

  return null;
};
